import React from "react";
import { TIPOS_AUTORIZACIONES } from "../../../utils/constants";
import { AutorizacionesAccordionMaterialesPresupuesto } from "./Accordions/AutorizacionesAccordionMaterialesPresupuesto";

const PracticaTipoPresupuestoSoloMateriales = (props) => {

  return (
    <div style={{ marginBottom: "2.8rem" }}>
      <AutorizacionesAccordionMaterialesPresupuesto
        practica={props.practica}
        disabled={props.disabled}
        desdeAuditar={props.desdeAuditar}
        esDenunciaInternacion={props.esDenunciaInternacion}
        idTipoSolicitud={TIPOS_AUTORIZACIONES.PRESUPUESTOS}
        evaluarPracticasMateriales={props.evaluarPracticasMateriales}
        estaCorrecto={true}
        noMostrarEstado={true}
      />
    </div>
  );
};

export default PracticaTipoPresupuestoSoloMateriales;
